import React, { useContext, useEffect, useState } from "react";
import Header from "./header";
import Footer from "./footer";
import HomeCounters from "./Homecounters";
import Testimonials from "./Testimonial";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import CitySelector from "./User/CitySelectore";
import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { useNavigate } from "react-router-dom";



function Legalclaimhelp() {

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        if (storedUser) {
          const parsedUser = JSON.parse(storedUser);
          setNewData((prevData) => ({
            ...prevData,
            user_name: parsedUser.name || "",
            user_email_address: parsedUser.email || "",
            user_phone_number: parsedUser.mobile || "",
            user_category: parsedUser.city || "",
          }));
        }
      }, []);

    const [activeQuestion, setActiveQuestion] = useState(null);
     const { http, token } = AuthUser();
   const navigate = useNavigate();
    const toggleQuestion = (questionId) => {
        setActiveQuestion((prev) => (prev === questionId ? null : questionId));
    };


    const [newData, setNewData] = useState({ user_name: '', user_email_address: '', user_phone_number: '', user_category: '' })

    const [errors, setErrors] = useState({});

       const { services, loading, error } = useContext(ServicesContext);  
       if (loading) {
          return <div>Loading...</div>;  // Show loading state while fetching data
      }
    
      if (error) {
           return <div>{error}</div> // Show error state if there was an issue fetching data
      }
       const service = services.find(s => s.service_id === 20);

    const validateForm = () => {
        const newErrors = {};

        // Name validation
        if (!newData.user_name.trim()) {
            newErrors.user_name = 'Name is required.';
        } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
            newErrors.user_name = '*Name should only contain letters and spaces.';
        }

        // Email validation
        if (!newData.user_email_address.trim()) {
            newErrors.user_email_address = 'Email is required.';
        } else if (!/\S+@\S+\.\S+/.test(newData.user_email_address)) {
            newErrors.user_email_address = 'Enter a valid email address.';
        }

        // Phone number validation
        // if (newData.user_phone_number && !/^\d{10}$/.test(newData.user_phone_number)) {
        //     newErrors.user_phone_number = 'Enter a valid 10-digit contact number.';
        // }

        if (!newData.user_phone_number.trim()) {
            newErrors.user_phone_number = 'number is required.';
          } else if (!/^\d{10}$/.test(newData.user_phone_number)) {
            newErrors.user_phone_number = 'Enter a valid 10-digit contact number.';
          }
   

        // Category validation
        if (!newData.user_category) {
            newErrors.user_category = 'Please select a category.';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0; // Return true if no errors
    };




    //    const formPutPartenshipdeed = async (e) => {
    //          e.preventDefault();
    //              // ✅ Check if user is logged in
    //      //   if (!token) {
    // //      alert("Please log in to continue.");
    // //      localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
    // //     navigate('/login'); // 👈 Use this if you're using React Router
    // //     return;
    // //  }
    //          if (!validateForm()) return;
           
    //         localStorage.setItem("bookingData", JSON.stringify(newData));

    //   // Navigate to checkout
    //   navigate('/checkout', {
    //      state: {
    //         service: service,

    //      }
    //   });
              
    //        };

    const formPutPartenshipdeed = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
        const response = await PartenerSheepDeedService.legalAdviceForm(newData);

        console.log("API Success:", response);

        navigate("/thankyou");

        // Optional: reset form
        setNewData(prev => {
  const resetObj = {};
  Object.keys(prev).forEach(key => (resetObj[key] = ""));
  return resetObj;
});
    

    } catch (error) {
        console.error("API Error:", error);
        alert("Something went wrong!");
    }
};


const handleBannerClick = () => {
  const formElement = document.querySelector(".contact3-form-all");

  if (formElement) {
    formElement.classList.add("shake-effect");

    // remove effect after animation finishes
    setTimeout(() => {
      formElement.classList.remove("shake-effect");
    }, 400); // same as animation duration
  }
};



    return (

        <>


            {/* <div className="legal-claim-help"> */}


            <div className="hero-area10 header-background">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="title title2 ">
                                <div className="headding-shape aniamtion-key-2">
                                    <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                                </div>
                                <h1 className="sk-text-color">Legal Advice</h1>
                                <p className="pdrl-text">Start Legal Advice with Only <span className="text-color"> Rs.{service?.price}/- </span><span></span>   </p>
                                <p className="pd-text">At Dm2Legal, we simplify legal claims with expert assistance, ensuring a smooth, stress-free experience. Our professionals handle the details, so you can focus on what matters most.
                                <br/>
                                    <br/>Reach out to Dm2Legal today and let us take the burden off your shoulders!</p>
                                <div className="space30"></div>
                               <div className="banner" onClick={handleBannerClick}>
   <img src="assets/icons/banner.svg" alt="" />
</div>

                            </div>
                        </div>
                        <div className="col-lg-4"> 
                            <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
                            <div className="contact3-form-all">
                                <div className="hadding7">
                                    <h3>Book Service Now </h3>
                                    <p className="pdrl-text"> Start with Only at Rs.{service?.price}/- <br/><span></span>  </p>
                                    {/* <p className="pdrl-text">at Rs.2251.00 only /-<span><br/>(Up to 30 Pages. Including GST)</span></p> */}
                                    {/* <p style={{ fontSize: "12px" }}>Further, the additional charges may apply with your mutual consent.</p> */}
                                </div>
                                <form action="#">
                                    <div className="form-input-all">
                                        <div className="form-input-box">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="input-single6">
                                                        <div className="">
                                                            <label for="">Name<span className="red">*</span></label>{errors.user_name && <p className="error-text">{errors.user_name}</p>}
                                                            <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="input-single6">
                                                        <div className="">
                                                            <label for="">Email Address<span className="red">*</span></label> {errors.user_email_address && <p className="error-text">{errors.user_email_address}</p>}
                                                            <input type="email" placeholder="Enter your Email Address" value={newData.user_email_address} onChange={(e) => setNewData({ ...newData, user_email_address: e.target.value })} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="input-single6">
                                                        <div className="">
                                                            <label for="">Contact Number<span className="red">*</span></label>{errors.user_phone_number && <p className="error-text">{errors.user_phone_number}</p>}
                                                            <input type="number" placeholder="Enter your Contact Number" value={newData.user_phone_number} onChange={(e) => setNewData({ ...newData, user_phone_number: e.target.value })} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-12">
                                                <CitySelector
                                          newData={newData}
                                          setNewData={setNewData}
                                          fieldKey="user_category"
                                          errors={errors}
                                       />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="space20"></div>
                                        <div className="btn-group-2">
                                            <a className="theme-btn-3" href="#" onClick={formPutPartenshipdeed}>Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="space80"></div>

            <div className="home4-counters">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">

                            <HomeCounters />
                        </div>
                    </div>
                    <div className="space40"></div>
                    <div className="row">
                        <div className="col-lg-12">
                            <p className="pd-text">Struggling with legal claims? Don’t let complexities hold you back! Our team of top lawyers is ready to help you navigate the process with ease. Contact us today for expert legal assistance!</p>
                            <p className="pd-text">Asserting your legal rights is essential, especially when seeking compensation for damages caused by another party. However, many individuals hesitate due to legal complexities, allowing others to take advantage.

                                At Dm2Legal, our Legal Claim Help service ensures you get the relief you deserve. Just share the necessary details, and our expert lawyers will handle the entire legal process for you.

                                Let us fight for your rights—contact us today for professional legal assistance!
                            </p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hadding7">
                                <div className="space40"></div>
                                <h2 className="text-center">How to apply</h2>
                                <div className="space20"></div>
                                <img src="assets/img/images/legal251-how-to-apply.png" className="how-to-apply" alt="" />
                                <div className="space20"></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div className="space40"></div>

            <div className="service-binifits9 "  >

                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="hadding7">
                                <h2 className="text-center">Benefits </h2>
                                <div className="service-binifits-boxs">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Enhance Productivity</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Protects your rights</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Effective Solution to Legal Problems</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Resolve Personal Disputes</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Recovery from financial losses</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Claim for Personal Injuries</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Get Adequate Compensation</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Standardized practices</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="single-boxs bg-box">
                                                &nbsp;&nbsp;
                                                <div className="icon">
                                                    <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                                        Legal Advantage</p>
                                                </div>
                                            </div>
                                        </div>
                                 

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="space30"></div>
                    </div>
                </div>
            </div>


            <div className="space40"></div>

            <div className="service-binifits9 sp0 last-section" id="service2">
                <div className="container work8">
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <div className="hadding7">
                                <div className="space80"></div>
                                <h2>Registration Process</h2>
                            </div>
                            <div className="partnership-deade-section">
                                <div className="space40"></div>

                                <ul className="disc-list">
                                    <li>
                                        <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                        <span>Our legal experts will carefully review all the documents you submit to minimize the risk of any incorrect or misleading information, ensuring a smooth process.</span>
                                        <svg className="pointer">
                                            <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                        </svg>
                                    </li>
                                    <li>
                                        <h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                        <span>Our top lawyers are here to assist you with document requirements and licensing needs.</span>
                                        <svg className="pointer">
                                            <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                        </svg>
                                    </li>
                                    <li>
                                        <h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                        <span>The lawyers will proceed with your documents to prepare your legal claim.</span>
                                        <svg className="pointer">
                                            <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                        </svg>
                                    </li>
                                    <li>
                                        <h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                                        <span>Once your documents have been successfully verified, our lawyers will prepare the legal claim on your behalf. You can then download it online from our website or the Dm2Legal app.</span>
                                        <svg className="pointer">
                                            <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                        </svg>
                                    </li>
                                    <li>
                                        <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                                        <span>It is advisable to wait until our expert contacts you to guide you through completing your legal claim.</span>
                                        <svg className="pointer">
                                            <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                                        </svg>
                                    </li>
                                </ul>

                                <div className="space80"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <div className="container">

                    <div className="row">
                        <div className="col-12">
                            <div className="faq-items" id="masonry-grid">
                                <div className="mesonry-item general single-price-list">
                                    <div className="faqs inner-faq">
                                        <h2 className="text-center">FREQUENTLY ASKED QUESTIONS</h2>
                                        <div className="space20"></div>


                                        <div id="general">


                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(1)}
                                                >
                                                    Q1. What does a Legal Claim mean?
                                                    <span>
                                                        {activeQuestion === 1 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                    A legal claim is a formal demand or request for compensation, enforcement of rights, or resolution of a dispute. It can be based on issues like contract breaches, damages, unpaid debts, or property disputes. The claim is typically presented in court or to the responsible party for resolution.                                                    </p>
                                                </div>
                                            </div>
                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(2)}
                                                >
                                                    Q2. What are the types of Legal Claims?
                                                    <span>
                                                        {activeQuestion === 2 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                        Legal claims typically fall into several categories, including:
                                                    </p>
                                                    <ul>
                                                        <li>Product liability cases</li>
                                                        <li>Workers' compensation cases</li>
                                                        <li>Social Security claims</li>
                                                        <li>Slip and fall claims</li>
                                                        <li>Car accidents, and more.</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(3)}
                                                >
                                                    Q3.What happens if I try to file a lawsuit without a valid legal claim?
                                                    <span>
                                                        {activeQuestion === 3 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                    If you attempt to file a lawsuit without a valid legal claim, your case may be dismissed by the court. You must have a legitimate reason or legal basis for your claim to proceed with legal action
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(4)}
                                                >
                                                    Q4. What distinguishes Legal Claims from Equitable Claims?
                                                    <span>
                                                        {activeQuestion === 4 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                    Legal claims are based on statutory rights and provide remedies like monetary compensation or property recovery, while equitable claims focus on fairness and may lead to non-monetary solutions like injunctions or specific performance.                                                    </p>
                                                </div>
                                            </div>
                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(5)}
                                                >
                                                    Q5. What is the time limit for filing a personal injury case in India?
                                                    <span>
                                                        {activeQuestion === 5 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                    In India, the time limit to file a personal injury case is generally three years from the date of the injury, as per the Limitation Act of 1963.                                                    </p>
                                                </div>
                                            </div>
                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(6)}
                                                >
                                                    Q6. How long does it take to settle a legal claim?
                                                    <span>
                                                        {activeQuestion === 6 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                    The time it takes to settle a legal claim varies depending on the complexity of the case, the parties involved, and the court's schedule. It can range from a few months to several years.                                                    </p>
                                                </div>
                                            </div>
                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(7)}
                                                >
                                                    Q7. Is hiring a lawyer necessary for a personal injury case?
                                                    <span>
                                                        {activeQuestion === 7 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                    While it's not mandatory, having a lawyer for a personal injury case is highly recommended. They can guide you through legal complexities, help with documentation, and increase your chances of getting fair compensation.                                                    </p>
                                                </div>
                                            </div>

                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 8 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(8)}
                                                >
                                                    Q8. What are the benefits of 'out of court settlements'?
                                                    <span>
                                                        {activeQuestion === 8 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 8 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                    Out of court settlements can save time and money, as they avoid lengthy court proceedings. They allow both parties to maintain privacy, reduce stress, and often result in a mutually agreeable resolution without the unpredictability of a trial.
                                                    </p>
                                                   
                                                </div>
                                            </div>

                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 9 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(9)}
                                                >
                                                    Q9. What are the three key elements to prove in a personal injury claim?
                                                    <span>
                                                        {activeQuestion === 9 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 9 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                    To win a personal injury claim, you must prove: 1) Duty of care – the defendant had a legal obligation to act responsibly. 2) Breach of duty – the defendant failed to meet that duty. 3) Causation – the breach directly caused the injury or harm.</p>
                                                  
                                                </div>
                                            </div>

                                            <div className="single-faq">
                                                <h2
                                                    className={`faq-heading font-f-3 weight-700 ${activeQuestion === 10 ? '' : 'collapsed'
                                                        }`}
                                                    id="faq-heading1"
                                                    onClick={() => toggleQuestion(10)}
                                                >
                                                    Q10. Can I file a legal claim in India without a lawyer?
                                                    <span>
                                                        {activeQuestion === 10 ? (
                                                            <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                                        ) : (
                                                            <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                                        )}
                                                    </span>
                                                </h2>
                                                <div
                                                    id="collapse1"
                                                    className={`accordion-collapse collapse ${activeQuestion === 10 ? 'show' : ''
                                                        }`}
                                                >
                                                    <p className="font-f-3 weight-500">
                                                    Yes, in India, you can file a legal claim without a lawyer, as individuals have the right to represent themselves in court. However, having legal representation is advisable to navigate complex procedures and ensure the best chances of success.                                                    </p>
                                                </div>
                                            </div>








                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <Testimonials />
            <div className="sp2 last-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 m-auto text-center">
                            <div className="hadding7">

                                <h2>Why Choose Us?</h2>
                            </div>
                        </div>
                    </div>
                    <div className="space30"></div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="service6-box">
                                <div className="">
                                    <div className="service-box-icon">
                                        <p>1</p>
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><span><img className="arow" src="assets/image/icons/growth.svg" alt="" /></span><a href="single-service-1.html" >Growth & Improvement</a></h4>
                                    <p>We are committed to continuous growth and improvement. To us, growth is the fundamental principle of life, and we strive to achieve it. We understand the significance of business growth and its importance to you.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="service6-box">
                                <div className="">
                                    <div className="service-box-icon">
                                        <p>2</p>
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >Support & Availability</a></h4>
                                    <p>We understand how even a small problem or query can cause frustration. That's why we are always available to provide support and resolve any issues you may have, whenever they arise.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="service6-box">
                                <div className="">
                                    <div className="service-box-icon">
                                        <p>3</p>
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                                    <p>Our team consists of experienced professionals who prioritize professionalism and customer satisfaction above all else. Each member is passionate about their respective field and dedicated to delivering the best service.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="service6-box">
                                <div className="">
                                    <div className="service-box-icon">
                                        <p>4</p>
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><span><img className="arow" src="assets/image/icons/focus.svg" alt="" /></span><a href="single-service-1.html" >Focus</a></h4>
                                    <p>We treat every task with the utmost importance. Our team members remain dedicated and focused on addressing even the smallest needs and requirements of our clients.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="service6-box">
                                <div className="">
                                    <div className="service-box-icon">
                                        <p>5</p>
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><span><img className="arow" src="assets/image/icons/value.svg" alt="" /></span><a href="single-service-1.html" >Value for Money</a></h4>
                                    <p>We understand the value of your hard-earned money. That's why we ensure that every penny you invest with us is utilized in the most effective way, delivering the best value for your investment.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="service6-box">
                                <div className="">
                                    <div className="service-box-icon">
                                        <p>6</p>
                                    </div>
                                </div>
                                <div className="hadding6">
                                    <h4><span><img className="arow" src="assets/image/icons/care.svg" alt="" /></span><a href="single-service-1.html" >Care & Regards</a></h4>
                                    <p>We consider you a part of our family, and your challenges and successes are our own. Your interests are our priority, and we are dedicated to fulfilling them with the utmost care and attention.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="space50"></div>

            <WhatsAppScrollButton />

            <Footer />

            <CircularScrollProgress />






        </>
    );
}

export default Legalclaimhelp;